export const shouldSkipPodiumCreate = true;